import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function PublicAuthRoute({ children, redirectTo = "/dashboard" }) {
  const auth = useSelector((state) => state.auth);

  if (auth.loading) return null;
  if (auth.isAuthenticated) return <Navigate to={redirectTo} replace />;
  return children;
}
